import keymaster from 'keymaster';

keymaster.TAB = 9;
keymaster.ESC = 27;
keymaster.SHIFT = 16;
keymaster.LEFT = 37;
keymaster.UP = 38;
keymaster.RIGHT = 39;
keymaster.DOWN = 40;

keymaster.filter = function (event) {
  var tagName = (event.target || event.srcElement).tagName;
  return !(tagName == 'SELECT');
};

keymaster.assign = keymaster;

let _lastKeyScope;

/**
 * Turn off any key bindings, but store the last scope so it can be reenabled
 */
keymaster.disable = () => {
  _lastKeyScope = keymaster.getScope();
  if (_lastKeyScope) {
    keymaster.setScope('disable everything scope');
  }
};

/**
 * Turn back on key bindings
 */
keymaster.enable = () => {
  if (_lastKeyScope) {
    keymaster.setScope(_lastKeyScope);
    _lastKeyScope = undefined;
  }
};

export default keymaster;
